import React from "react";
import { SouthRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

import { AccountBox } from "./AccountBox";

type AccountSwitchDisplayProps = {
  currentAccountName: string;
  targetAccountName: string;
  warningMessage?: string;
};

/**
 * Displays two accounts (current and target) with an arrow between them,
 * used for account switching flows.
 */
export const AccountSwitchDisplay: React.FC<AccountSwitchDisplayProps> = ({
  currentAccountName,
  targetAccountName,
  warningMessage = "Switching accounts will reload your workspace. Make sure any work in progress is saved first.",
}) => {
  return (
    <>
      <AccountBox accountName={currentAccountName} isCurrent />
      <Box width="100%" sx={{ display: "flex", justifyContent: "center" }}>
        <SouthRounded color="action" fontSize="small" />
      </Box>
      <AccountBox accountName={targetAccountName} isCurrent={false} />
      {warningMessage && <Typography>{warningMessage}</Typography>}
    </>
  );
};
